import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Search from '../components/search'
import Loading from '../components/loading'
import Ajax from '../components/ajax'
import { useDispatch } from 'react-redux'
import { userLogin } from '../store/slices/mainSlices'
import Pagination from '../components/pagination'
import Modal from '../components/modal'
import { useForm } from 'react-hook-form'

export default function Staff() {
  //Translate initialization
  const { t } = useTranslation()
  document.title = 'Staff | ' + t('name')

  //State manager initialization
  const dispatch = useDispatch()
  const [contentPerPage] = useState(10)
  const [search, setSearch] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const [currentTable, setCurrentTable] = useState(null)
  const [tableArray, setTableArray] = useState(null)
  const [pagination, setPagination] = useState('')
  const [staffList, setStaffList] = useState('')
  const [modalEdit, setModalEdit] = useState(false)
  const [positions, setPositions] = useState(null)
  const [currentRequest, setCurrentRequest] = useState('')
  const [myCurrentId, setMyCurrentId] = useState('')

  //Modal for edit
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors, isValid },
  } = useForm({
    mode: 'onChange',
    defaultValues: {
      staffValues: {
        code: '',
        id: '',
        name: '',
        surname: '',
        phone: '',
        email: '',
        positionCode: '',
        education: '',
      },
    },
    reValidateMode: 'onChange',
  })

  //Get current table for page
  const selectTable = event => {
    if (event.target.value === 'administrations' || event.target.value === 'teachers' || event.target.value === 'workers') {
      setCurrentTable(event.target)
    }
  }

  //Request for positions
  useEffect(() => {
    const ajaxBody = {}
    const method = 'post'
    const ajaxUrl = 'manager/positions/getAll'

    const promise = new Promise((resolve, reject) => {
      Ajax(ajaxBody, ajaxUrl, resolve, method)
    })

    promise.then(data => {
      const dataResponse = data.responseCode.responseCode
      if (dataResponse === '1') {
        setValue(
          'staffValues',
          {
            positionCode: data.data[0].id,
          },
          { shouldValidate: true }
        )
        setPositions(
          Object.values(data.data).map(child => {
            return (
              <option value={child.id} key={child.id}>
                {child.code}
              </option>
            )
          })
        )
      } else if (dataResponse === '105' || dataResponse === '104' || dataResponse === '103') {
        dispatch(userLogin(false))
        localStorage.removeItem('userToken')
        localStorage.removeItem('userLogin')
      } else {
        console.log(data.responseCode.responseCode)
      }
    })
  }, [dispatch, setValue])

  //Request for all staff
  const getAllStaff = useCallback(() => {
    const ajaxBody = {}
    const method = 'post'
    const ajaxUrl = `manager/${currentTable ? currentTable.value : 'administrations'}/getAll`

    const promise = new Promise((resolve, reject) => {
      Ajax(ajaxBody, ajaxUrl, resolve, method)
    })

    promise.then(data => {
      const dataResponse = data.responseCode.responseCode
      if (dataResponse === '1') {
        const container = document.querySelector('.tableButton').querySelectorAll('button')
        container.forEach(element => {
          element.classList.remove('active')
        })
        if (currentTable) {
          currentTable.classList.add('active')
        } else {
          document.querySelector('.tableButton').querySelector('button').classList.add('active')
        }
        const newArr = data.data.map(item => {
          const tempObj = {}
          for (let key in item) {
            if (item[key] === null) {
              tempObj[key] = ''
              continue
            }
            tempObj[key] = item[key]
          }
          return tempObj
        })
        setTableArray(newArr)
      } else if (dataResponse === '105' || dataResponse === '104' || dataResponse === '103') {
        dispatch(userLogin(false))
        localStorage.removeItem('userToken')
        localStorage.removeItem('userLogin')
      } else {
        console.log(data.responseCode.responseCode)
      }
    })
  }, [currentTable, dispatch])

  //Request for current table
  useEffect(() => {
    getAllStaff()
  }, [currentTable, getAllStaff])

  //Request for delete Employer
  const deleteStaff = useCallback(
    event => {
      const ajaxUrl = `manager/${currentTable ? currentTable.value : 'administrations'}/delete`
      const ajaxBody = {
        id: myCurrentId,
      }
      const method = 'post'

      const promise = new Promise((resolve, reject) => {
        Ajax(ajaxBody, ajaxUrl, resolve, method)
      })

      promise.then(data => {
        const dataResponse = data.responseCode.responseCode
        if (dataResponse === '1') {
          const newDeleteArray = tableArray.slice()
          const indexDelete = newDeleteArray.indexOf(newDeleteArray.find(child => child.id === Number(event.target.dataset.value)))
          newDeleteArray.splice(indexDelete, 1)
          setTableArray(newDeleteArray)
        } else if (dataResponse === '105' || dataResponse === '104' || dataResponse === '103') {
          dispatch(userLogin(false))
          localStorage.removeItem('userToken')
          localStorage.removeItem('userLogin')
        } else {
          console.log(data.responseCode.responseCode)
        }
      })
    },
    [tableArray, dispatch, currentTable, myCurrentId]
  )

  const oneStaff = useCallback(
    event => {
      const ajaxUrl = `manager/${currentTable ? currentTable.value : 'administrations'}/getOne`
      const ajaxBody = {
        id: event.target.dataset.value,
      }
      setMyCurrentId(event.target.dataset.value)
      const method = 'post'

      const promise = new Promise((resolve, reject) => {
        Ajax(ajaxBody, ajaxUrl, resolve, method)
      })

      promise.then(data => {
        const dataResponse = data.responseCode.responseCode
        if (dataResponse === '1') {
          setValue(
            'staffValues',
            {
              id_number: data.data.id_number,
              name: data.data.name,
              surname: data.data.last_name,
              phone: data.data.phone,
              email: data.data.email,
              positionCode: data.data.position_id,
              education: data.data.education,
            },
            { shouldValidate: true }
          )
          setCurrentRequest('update')
          setModalEdit(true)
        } else if (dataResponse === '105' || dataResponse === '104' || dataResponse === '103') {
          dispatch(userLogin(false))
          localStorage.removeItem('userToken')
          localStorage.removeItem('userLogin')
        } else {
          console.log(data.responseCode.responseCode)
        }
      })
    },
    [setValue, currentTable, dispatch]
  )

  const sendStaff = data => {
    if (currentRequest === 'add') {
      const ajaxUrl = `manager/${currentTable ? currentTable.value : 'administrations'}/${currentRequest}`
      const ajaxBody = {
        id_number: data.staffValues.id,
        name: data.staffValues.name,
        last_name: data.staffValues.surname,
        phone: data.staffValues.phone,
        email: data.staffValues.email,
        position_id: data.staffValues.positionCode,
        education: data.staffValues.education,
        password: '123456',
        password_confirmation: '123456',
      }
      const method = 'post'

      const promise = new Promise((resolve, reject) => {
        Ajax(ajaxBody, ajaxUrl, resolve, method)
      })

      promise.then(data => {
        const dataResponse = data.responseCode.responseCode
        if (dataResponse === '1') {
          reset()
          setModalEdit(false)
          getAllStaff()
        } else if (dataResponse === '105' || dataResponse === '104' || dataResponse === '103') {
          dispatch(userLogin(false))
          localStorage.removeItem('userToken')
          localStorage.removeItem('userLogin')
        } else {
          console.log(data.responseCode.responseCode)
        }
      })
    } else {
      const ajaxUrl = `manager/${currentTable ? currentTable.value : 'administrations'}/${currentRequest}`
      const ajaxBody = {
        id: myCurrentId,
        id_number: data.staffValues.id,
        name: data.staffValues.name,
        last_name: data.staffValues.surname,
        phone: data.staffValues.phone,
        email: data.staffValues.email,
        position_id: data.staffValues.positionCode,
        education: data.staffValues.education,
        password: '123456',
        password_confirmation: '123456',
      }
      const method = 'post'

      const promise = new Promise((resolve, reject) => {
        Ajax(ajaxBody, ajaxUrl, resolve, method)
      })

      promise.then(data => {
        const dataResponse = data.responseCode.responseCode
        if (dataResponse === '1') {
          reset()
          setModalEdit(false)
          getAllStaff()
        } else if (dataResponse === '105' || dataResponse === '104' || dataResponse === '103') {
          dispatch(userLogin(false))
          localStorage.removeItem('userToken')
          localStorage.removeItem('userLogin')
        } else {
          console.log(data.responseCode.responseCode)
        }
      })
    }
  }

  //Table list for HTML
  useEffect(() => {
    if (tableArray) {
      const lastPageIndex = currentPage * contentPerPage
      const firstPageIndex = lastPageIndex - contentPerPage
      const currentMyPage = tableArray
        .filter(
          element =>
            element.name.toLowerCase().includes(search.toLowerCase()) +
            element.code.toLowerCase().includes(search.toLowerCase()) +
            element.last_name.toLowerCase().includes(search.toLowerCase()) +
            element.phone.toLowerCase().includes(search.toLowerCase()) +
            element.email.toLowerCase().includes(search.toLowerCase()) +
            element.id_number.toLowerCase().includes(search.toLowerCase()) +
            element.position_code.toLowerCase().includes(search.toLowerCase())
        )
        .slice(firstPageIndex, lastPageIndex)
      if (currentMyPage.length === 0) {
        setStaffList(<p className='nothingFound'>Nothing found</p>)
      } else {
        setStaffList(
          Object.values(currentMyPage).map(child => {
            return (
              <div className='item mainItem' key={child.id} data-value={child.id} onClick={event => oneStaff(event)}>
                <p title={child.code} data-value={child.id} className='code'>
                  {child.code}
                </p>

                <p title={child.name} data-value={child.id}>
                  {child.name}
                </p>
                <p title={child.last_name} data-value={child.id}>
                  {child.last_name}
                </p>
                <p title={child.phone} data-value={child.id}>
                  {child.phone}
                </p>
                <p title={child.email} data-value={child.id}>
                  {child.email}
                </p>
                <p title={child.id_number} data-value={child.id}>
                  {child.id_number}
                </p>
                <p title={child.position_code} data-value={child.id}>
                  {child.position_code}
                </p>
                <p title={child.education} data-value={child.id}>
                  {child.education}
                </p>
              </div>
            )
          })
        )
        setPagination(
          <Pagination
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
            search={search}
            allEmployers={tableArray}
            contentPerPage={contentPerPage}
          />
        )
      }
    } else {
      setStaffList(<Loading />)
      setPagination(null)
    }
  }, [tableArray, search, currentPage, contentPerPage, oneStaff, deleteStaff])

  return (
    <section className='staff'>
      <div className='addNew'>
        <h2>Staff</h2>
        <Search search={search} setSearch={setSearch} setCurrentPage={setCurrentPage} />
        <button
          value='addNew'
          onClick={function () {
            reset()
            setModalEdit(true)
            setCurrentRequest('add')
          }}>
          Add
        </button>
      </div>
      <div className='table'>
        <div onClick={event => selectTable(event)} className='tableButton'>
          <button value='administrations' className='active'>
            Administration
          </button>
          <button value='teachers'>Teachers</button>
          <button value='workers'>Workers</button>
        </div>
        <div className='item title'>
          <h2 className='code'>Code</h2>
          <h2>Name</h2>
          <h2>Surname</h2>
          <h2>Phone number</h2>
          <h2>E-mail</h2>
          <h2>ID</h2>
          <h2>Position code</h2>
          <h2>Education</h2>
        </div>
        {staffList}
      </div>
      {pagination}
      <Modal active={modalEdit} setActive={setModalEdit}>
        <h2>Staff info</h2>
        <form onSubmit={handleSubmit(sendStaff)} autoComplete='off'>
          <div className='labelDiv'>
            <div>
              <label>
                <p>
                  Name <span className='requiredInput'>*</span>
                </p>
                <input
                  {...register('staffValues.name', {
                    required: 'This field is required',
                    minLength: {
                      value: 3,
                      message: 'Min length 3',
                    },
                    maxLength: {
                      value: 50,
                      message: 'Max length 50',
                    },
                  })}
                />
              </label>
              <span className='errorResponse'>
                {errors.hasOwnProperty('staffValues') && errors.staffValues.hasOwnProperty('name') ? errors.staffValues.name.message : null}
              </span>
            </div>
            <div>
              <label>
                <p>
                  Surname <span className='requiredInput'>*</span>
                </p>
                <input
                  {...register('staffValues.surname', {
                    required: 'This field is required',
                    minLength: {
                      value: 3,
                      message: 'Min length 6',
                    },
                    maxLength: {
                      value: 50,
                      message: 'Max length 100',
                    },
                  })}
                />
              </label>
              <span className='errorResponse'>
                {errors.hasOwnProperty('staffValues') && errors.staffValues.hasOwnProperty('surname') ? errors.staffValues.surname.message : null}
              </span>
            </div>
          </div>
          <div className='labelDiv'>
            <div>
              <label>
                <p>
                  Phone number <span className='requiredInput'>*</span>
                </p>
                <input
                  type='number'
                  {...register('staffValues.phone', {
                    required: 'This field is required',
                    minLength: {
                      value: 6,
                      message: 'Min length 6',
                    },
                    maxLength: {
                      value: 100,
                      message: 'Max length 100',
                    },
                  })}
                />
              </label>
              <span className='errorResponse'>
                {errors.hasOwnProperty('staffValues') && errors.staffValues.hasOwnProperty('phone') ? errors.staffValues.phone.message : null}
              </span>
            </div>
            <div>
              <label>
                <p>
                  Email <span className='requiredInput'>*</span>
                </p>
                <input
                  {...register('staffValues.email', {
                    required: 'This field is required',
                    minLength: {
                      value: 6,
                      message: 'Min length 6',
                    },
                    maxLength: {
                      value: 100,
                      message: 'Max length 100',
                    },
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: 'invalid email address',
                    },
                  })}
                />
              </label>
              <span className='errorResponse'>
                {errors.hasOwnProperty('staffValues') && errors.staffValues.hasOwnProperty('email') ? errors.staffValues.email.message : null}
              </span>
            </div>
          </div>
          <label>
            <p>ID</p>
            <input
              {...register('staffValues.id', {
                maxLength: {
                  value: 50,
                  message: 'Max length 50',
                },
              })}
            />
          </label>
          <span className='errorResponse'>
            {errors.hasOwnProperty('staffValues') && errors.staffValues.hasOwnProperty('id') ? errors.staffValues.id.message : null}
          </span>
          <label>
            Position code
            <select
              {...register('staffValues.positionCode', {
                required: 'This field is required',
              })}>
              {positions}
            </select>
          </label>
          <span className='errorResponse'>
            {errors.hasOwnProperty('staffValues') && errors.staffValues.hasOwnProperty('positionCode')
              ? errors.staffValues.positionCode.message
              : null}
          </span>
          <label>
            Education
            <input
              {...register('staffValues.education', {
                maxLength: {
                  value: 100,
                  message: 'Max length 100',
                },
              })}
            />
          </label>
          <span className='errorResponse'>
            {errors.hasOwnProperty('staffValues') && errors.staffValues.hasOwnProperty('education') ? errors.staffValues.education.message : null}
          </span>
          <div className='buttons'>
            <input type='submit' className='sendButton' value='Save' disabled={!isValid} />
            <span className={currentRequest === 'add' ? 'none' : 'sendButton delete'} onClick={() => deleteStaff()}>
              Delete
            </span>
          </div>
        </form>
      </Modal>
    </section>
  )
}
